import type { FC } from "react";
import { tv } from "tailwind-variants";

import type {
  ActionActionItemUnion,
  ExternalNavigation,
  InternalNavigation,
} from "~/core";
import { Button } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";

import type { BannerVariant, MainBannerV2Props } from "../MainBannerV2";

type MainBannerButtonsProps = MainBannerV2Props & {
  bannerVariant?: BannerVariant;
};

const buttonStyles = tv({
  base: "[font-size:var(--fontSize-mobile-large-body)] [line-height:var(--lineHeight-mobile-large-body)] md:[font-size:var(--fontSize-desktop-large-body)] md:[line-height:var(--lineHeight-desktop-large-body)] text-nowrap h-12 md:h-16",
  variants: {
    variant: {
      column: " w-[160px]  md:min-w-[240px] md:p-[17px] ",
      row: "w-[148px] md:min-w-[214px]",
    },
  },
  defaultVariants: {
    variant: "column",
  },
});

const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};
export const MainBannerButtons: FC<MainBannerButtonsProps> = ({
  data,
  getUrl,
  bannerVariant = "column",
  onCallAction,
  isControlInactive,
}) => {
  return (
    <Flex
      align="center"
      justify="center"
      gap={bannerVariant === "column" ? 8 : 16}
      d={{ gap: bannerVariant === "column" ? 14 : 16 }}
      className="mt-auto"
    >
      {data.controls
        ?.filter((control) => {
          if (control?.main_banner_controls_id?.action) {
            return !isControlInactive(control.main_banner_controls_id.action);
          }

          return true;
        })
        .map((control) => {
          const action = control?.main_banner_controls_id?.action?.action?.[0];
          let href;
          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }
          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }
          return (
            <Button
              href={href}
              key={control?.id}
              variant={
                control?.main_banner_controls_id?.variant === "primary"
                  ? "default"
                  : "transparent"
              }
              weight="bold"
              className={buttonStyles({ variant: bannerVariant })}
              onPress={() => {
                if (action) {
                  onCallAction(action);
                }
              }}
            >
              {control?.main_banner_controls_id?.text}
            </Button>
          );
        })}
    </Flex>
  );
};
